import { buildTransactionFilterQuery } from '../../util/transactionFilterUtils'
import { TransactionSelectFilterTypes } from '../../util/transactionConstants'
// TODO This file exports functions copied from Payment-engine-request-builder
//  they can be removed from Payment-engine-request-builder when migrated to Payment-engine-search-service

const fields = [
  'PAYMENT_EXTERNAL_ID',
  'CUSTOMER_GOVERNMENT_ID',
  'CUSTOMER_FULL_NAME',
  'PAYMENT_STATUS',
  'PAYMENT_TOTAL_VALUE',
  'PAYMENT_CREATED',
]

const { DEBIT, FROZEN } = TransactionSelectFilterTypes

export const createSearchBody = requestData => {
  switch (requestData.filter) {
    case FROZEN:
      return {
        paymentSearchCriteria: {
          fields,
          searchString: requestData.searchTerm,
        },
        frozen: true,
      }
    case DEBIT:
      return {
        paymentSearchCriteria: {
          fields,
          searchString: requestData.searchTerm,
        },
        hasStatuses: ['DEBITABLE'],
        frozen: false,
        // TA BORT?
        authorizedFrom: '2018-05-01T13:22:11.495Z',
      }
    default:
      return {
        paymentSearchCriteria: {
          fields,
          searchString: requestData.searchTerm,
        },
        // TA BORT?
        authorizedFrom: '2018-05-01T13:22:11.495Z',
      }
  }
}

export const createSearchRequestBody = ({
  filters,
  searchTerm,
  startDate,
  endDate,
}) => ({
  filters: Array.isArray(filters)
    ? filters
    : buildTransactionFilterQuery(filters),
  searchQuery: searchTerm,
  startDate,
  endDate,
})
